import React, { useState, useEffect } from 'react';
import imagePlaceholder from '../assets/img/imagePlaceholder.png';
import { getSlashFormattedDate } from '../../../../../../utils/dateTimeFormatter';
import { Link } from 'react-router-dom';
import favorite from '../assets/img/favorite.png';
import location from '../assets/img/location.png';
import { Dialog } from '@mui/material';
import { connect } from 'react-redux';
import { userProfileViewListStart } from '../../../../../../redux/athlete/dashboard/colleges/userProfileView';
import {
  saveOffersQuery,
  saveUserCollegeQuery,
  getUserCollegedata,
} from '../../editUserProfile/OfferQuery';
import { getUserInfo } from '../../../../../../services/authService';
import { offersListsaveStart } from '../../../../../../redux/athlete/dashboard/editUserProfile/offers';
import { addMyCommitmentStart } from '../../../../../../redux/athlete/profile/commitment';
import { saveSignedCommitment } from '../../homepage/leftSideBar/query';
import warningMessagePopup from '../../../../../../utils/warningMagPop';
import trashCircleIcon from '../../Message/img/trash-circle-icon.svg';
import { saveMyCommitmentQuery } from '../../profile/ProfileEdit/profileQuery';
import { updateUserCollegeStart } from '../../../../../../redux/athlete/dashboard/colleges/updateUserCollege';
import Map from '../Map';
import swal from 'sweetalert';
import { messageReplyListStart } from '../../../../../../redux/athlete/dashboard/messageReply/messageReply';
import { getCollegesCountsQuery } from './CollegeListQuery';
import { userCollegeCardCountStart } from '../../../../../../redux/athlete/dashboard/colleges/userCollegeCardCount';
import { fetchGraphMethod } from '../../../../../../services/httpService';
import { imageDownloadUrl } from '../../../../../../config';
import { fetchMethod } from '../../../../../../services/httpService';
import { viewCollegeSaveStart } from '../../../../../../redux/athlete/dashboard/colleges/viewCollege';
import { saveViewCollegeQuery } from '../searchColleges/SearchCollegesQuery';
import {
  sendRemoveOfferNotification,
  sendRemoveCommitmentNotification,
} from '../../../../../../utils/sendNotificationToAdvisor';
import toastr from 'toastr';
import CollegeOverview from './CollegeOverview';
import { CollegeProgressSteps } from '../../../../../../constants';

const initialStepsList = [
  {
    label: CollegeProgressSteps.TARGET,
    active: false,
    passed: false,
  },
  {
    label: CollegeProgressSteps.CONTACT,
    active: false,
    passed: false,
  },
  {
    label: CollegeProgressSteps.INTEREST,
    active: false,
    passed: false,
  },
  {
    label: CollegeProgressSteps.ACTIVE,
    active: false,
    passed: false,
  },
  {
    label: CollegeProgressSteps.OFFER,
    active: false,
    passed: false,
  },
  {
    label: CollegeProgressSteps.COMMIT,
    active: false,
    passed: false,
  },
  {
    label: CollegeProgressSteps.SIGNED,
    active: false,
    passed: false,
  },
];
export const CollegeCard = (props) => {
  const {
    collegeId,
    userCollegeId,
    stepperSteps,
    logo,
    name,
    rank,
    conference,
    city,
    state,
    stateInitials,
    division,
    categoryId,
    interestLevelId,
    updatedOn,
    academicSelectivity,
    schoolSize,
    tuitionInCost,
    tuitionOutCost,
    lat,
    lng,
    isTagged,
    commit,
    offer,
    mySignedCommitment,
    myOffers,
    getAllCommitmentList,
    getAllOfferList,
    getSearchCollegesData,
  } = props;
  const imgSrc = logo ? `${imageDownloadUrl}/${logo}` : imagePlaceholder;

  const [offerModal, setOfferModal] = useState(false);
  const [commitModal, setCommitModal] = useState(false);
  const [signedModal, setSignedModal] = useState(false);
  const [openMap, setOpenMap] = useState(false);
  const [isFavCollegeOffer, setIsFavCollegeOffer] = useState([]);
  const [stepsList, setStepsList] = React.useState(initialStepsList);
  const [commitCollegeid, setCommitCollegeid] = useState(null);
  const [profileViews, setProfileViews] = useState([]);
  const [msgReplyArray, setMsgReplyArray] = useState([]);
  const [myInterestLevel, setMyInterestLevel] = useState(interestLevelId);
  const [category, setCategory] = useState(categoryId);
  const [steps, setSteps] = useState(stepperSteps);

  const getCardCount = () => {
    props.userCollegeCardCountStart({
      query: getCollegesCountsQuery(getUserInfo().id),
    });
  };

  const deleteSignedCommitment = async (commitId) => {
    await fetchGraphMethod(
      saveSignedCommitment,
      {
        obj: {
          id: commitId,
          active: 0,
        },
      },
      true
    ).then(() => {
      toastr.success('Signed Commitment deleted successfully', '', {
        progressBar: true,
        timeOut: 2000,
        closeButton: true,
        positionClass: 'toast-top-full-width',
        showEasing: 'swing',
        fadeIn: 40000,
        preventDuplicates: true,
      });
    });
  };

  useEffect(() => {
    if (
      props.messageReplyList.data &&
      props.messageReplyList.data.data &&
      props.messageReplyList.data.data.length !== 0
    ) {
      msgReplyArray.push(props.messageReplyList.data.data);
    }
  }, [props.messageReplyList.data]);

  useEffect(() => {
    if (props.profileView.data && props.profileView.data.totalCount !== 0) {
      profileViews.push(props.profileView.data.Userprofileviews);
    }
  }, [props.profileView.data]);

  useEffect(() => {
    const stepsListT = stepsList.map((item, index) => {
      if (index + 1 < steps) {
        return {
          ...item,
          active: false,
          passed: true,
        };
      }
      if (index + 1 === steps) {
        return {
          ...item,
          active: true,
          passed: false,
        };
      }
      if (index + 1 > steps) {
        return {
          ...item,
          active: false,
          passed: false,
        };
      }
    });
    setStepsList(stepsListT);
  }, [steps, isFavCollegeOffer]);
  const closeOfferModal = () => {
    setOfferModal(false);
  };
  const closeCommitModal = () => {
    setCommitModal(false);
  };
  const closeSignedModal = () => {
    setSignedModal(false);
  };
  const UserCommit = async () => {
    const userCommitVar = {
      obj: {
        userid: getUserInfo() && getUserInfo().id ? getUserInfo().id : null,
        commit: 1,
        order: 'id desc',
      },
      first: 1,
      last: 1,
    };
    const userCollegeData = await fetchGraphMethod(
      getUserCollegedata,
      userCommitVar,
      true
    );
    const userCommitId = userCollegeData.data.data.allUsercolleges.Usercolleges;
    return userCommitId;
  };
  const deleteNextScreen = async (collegeId, commitCollegeid, label) => {
    const userCollegeCommt = await UserCommit();
    props.updateUserCollegeStart({
      query: saveUserCollegeQuery,
      variables:
        label === CollegeProgressSteps.COMMIT && userCollegeCommt != ''
          ? {
              obj: {
                userid:
                  getUserInfo() && getUserInfo().id ? getUserInfo().id : null,
                id: userCollegeCommt[0].id,
                target: 1,
                contact: 1,
                interest: 1,
                collegeactive: 1,
                offer: 1,
                commit: 0,
                signed: 0,
                alumni: 0,
              },
            }
          : {
              obj: {
                userid:
                  getUserInfo() && getUserInfo().id ? getUserInfo().id : null,
                id: userCollegeCommt[0].id,
                target: 1,
                contact: 1,
                interest: 1,
                collegeactive: 1,
                offer: 1,
                commit: 0,
                signed: 0,
                alumni: 0,
              },
            },
      getCardCount: getCardCount,
    });

    if (mySignedCommitment.length > 0) {
      await deleteSignedCommitment(mySignedCommitment[0].id);
    }

    // messagepopup changed to toastr
    toastr.success('Commitment Deleted Successfully.', '', {
      progressBar: true,
      timeOut: 2000,
      closeButton: true,
      positionClass: 'toast-top-full-width',
      showEasing: 'swing',
      fadeIn: 40000,
      preventDuplicates: true,
    });
  };
  useEffect(() => {
    const commitmentData =
      props.commitmentList && props.commitmentList.data
        ? props.commitmentList.data
        : null;
    const commitCollegeId =
      props.collegesList &&
      props.collegesList.filter((college) => {
        return (
          commitmentData &&
          commitmentData[0] &&
          commitmentData[0].collegeid === college.collegeid
        );
      });
    if (commitCollegeId && commitCollegeId[0] && commitCollegeId[0].id) {
      setCommitCollegeid(commitCollegeId[0].id);
    }
  }, [props.commitmentList.data]);

  const handleStepperUpdateData = async (index, label) => {
    const commitmentData =
      props.commitmentList && props.commitmentList.data
        ? props.commitmentList.data
        : null;
    if (
      (label === CollegeProgressSteps.COMMIT && commit !== 1) ||
      (label === CollegeProgressSteps.SIGNED && commit !== 1) ||
      (commit == 1 && label == CollegeProgressSteps.OFFER)
    ) {
      if (commitmentData && commitmentData.length !== 0) {
        const confirmation =
          label == 'Offer'
            ? warningMessagePopup(
                '',
                'Are you sure you want to delete this commitment?',
                trashCircleIcon
              )
            : warningMessagePopup(
                '',
                'Are you sure you want to decommit from the college that you have added to your list earlier?',
                trashCircleIcon
              );
        confirmation.then(async (value) => {
          if (value == true) {
            const commitVariables = {
              obj: {
                id:
                  commitmentData && commitmentData[0].id
                    ? commitmentData[0].id
                    : null,
                active: 0,
              },
            };

            const removeCollegeCommitment = await fetchGraphMethod(
              saveMyCommitmentQuery,
              commitVariables,
              true
            );

            // delete signed commitment as well if exists
            if (mySignedCommitment.length > 0) {
              const signedCommitmentVariables = {
                obj: {
                  id: mySignedCommitment[0].id,
                  active: 0,
                },
              };
              const removeSignedCommitment = await fetchGraphMethod(
                saveSignedCommitment,
                signedCommitmentVariables,
                true
              );
              if (removeSignedCommitment?.status !== 200) {
                toastr.error('Oops! Commitment not Deleted Successfully', '', {
                  progressBar: true,
                  timeOut: 2000,
                  closeButton: true,
                  positionClass: 'toast-top-full-width',
                  showEasing: 'swing',
                  fadeIn: 40000,
                  preventDuplicates: true,
                });
              }
            }

            if (removeCollegeCommitment?.status == 200) {
              await deleteNextScreen(collegeId, commitCollegeid, label);
              await getAllCommitmentList();
              setSteps(index + 1);
              sendRemoveCommitmentNotification(name);
              getSearchCollegesData();
              if (label === CollegeProgressSteps.COMMIT) {
                setCommitModal(true);
              } else if (label === CollegeProgressSteps.SIGNED) {
                setSignedModal(true);
              }
            } else {
              toastr.error('Oops! Commitment not Deleted Successfully', '', {
                progressBar: true,
                timeOut: 2000,
                closeButton: true,
                positionClass: 'toast-top-full-width',
                showEasing: 'swing',
                fadeIn: 40000,
                preventDuplicates: true,
              });
            }
          }
        });
      } else if (label == CollegeProgressSteps.COMMIT) {
        setCommitModal(true);
      } else if (label == CollegeProgressSteps.SIGNED) {
        setSignedModal(true);
      }
    } else if (label === CollegeProgressSteps.SIGNED) {
      setSignedModal(true);
    } else if (label === CollegeProgressSteps.COMMIT) {
      setCommitModal(true);
    }
    if (label == CollegeProgressSteps.OFFER && commit == 0) {
      isCollegeAddedToOffer();
      setOfferModal(true);
    }
    if (
      (label == CollegeProgressSteps.ACTIVE ||
        label == CollegeProgressSteps.TARGET ||
        label == CollegeProgressSteps.CONTACT ||
        label == CollegeProgressSteps.INTEREST) &&
      commit == 1
    ) {
      const collegeOfferValue = isCollegeAddedToOffer();
      const commitmentData =
        props.commitmentList && props.commitmentList.data
          ? props.commitmentList.data
          : null;
      if (
        collegeOfferValue &&
        collegeOfferValue.length !== 0 &&
        commitmentData &&
        commitmentData.length !== 0
      ) {
        const confirmation = warningMessagePopup(
          '',
          'Are you sure you want to delete this offer and commitment?',
          trashCircleIcon
        );
        confirmation.then(async (value) => {
          if (value == true) {
            const variables = {
              obj: {
                id:
                  collegeOfferValue && collegeOfferValue[0].id
                    ? collegeOfferValue[0].id
                    : null,
                active: 0,
              },
            };
            const updateOfferData = await fetchGraphMethod(
              saveOffersQuery,
              variables,
              true
            );
            if (updateOfferData?.status == 200) {
              await deleteCommitment(commitmentData, collegeId);
              props.handleStepperUpdate(userCollegeId, index + 1);
              getSearchCollegesData();
              setSteps(index + 1);
              sendRemoveOfferNotification(name);
              sendRemoveCommitmentNotification(name);
            } else {
              toastr.error(
                'Oops! Offer and commitment not deleted successfully.',
                '',
                {
                  progressBar: true,
                  timeOut: 2000,
                  closeButton: true,
                  positionClass: 'toast-top-full-width',
                  showEasing: 'swing',
                  fadeIn: 40000,
                  preventDuplicates: true,
                }
              );
            }
          }
        });
      } else {
        props.handleStepperUpdate(userCollegeId, index + 1);
      }
    } else if (
      (label == CollegeProgressSteps.ACTIVE ||
        label == CollegeProgressSteps.TARGET ||
        label == CollegeProgressSteps.CONTACT ||
        label == CollegeProgressSteps.INTEREST) &&
      offer == 1
    ) {
      const collegeOffersData = isCollegeAddedToOffer();
      if (collegeOffersData && collegeOffersData.length > 0) {
        const confirmation = warningMessagePopup(
          '',
          'Are you sure you want to delete this offer?',
          trashCircleIcon
        );
        confirmation.then(async (value) => {
          if (value == true) {
            const offerVariables = {
              obj: {
                id:
                  collegeOffersData && collegeOffersData[0].id
                    ? collegeOffersData[0].id
                    : null,
                active: 0,
              },
            };
            const deleteCollegeOffer = await fetchGraphMethod(
              saveOffersQuery,
              offerVariables,
              true
            );
            if (deleteCollegeOffer?.status == 200) {
              toastr.success('Offer deleted successfully', '', {
                progressBar: true,
                timeOut: 2000,
                closeButton: true,
                positionClass: 'toast-top-full-width',
                showEasing: 'swing',
                fadeIn: 40000,
                preventDuplicates: true,
              });
              sendRemoveOfferNotification(name);
              setSteps(index + 1);
              props.handleStepperUpdate(userCollegeId, index + 1);
              getAllOfferList();
              getSearchCollegesData();
            }
          }
        });
      } else {
        props.handleStepperUpdate(userCollegeId, index + 1);
      }
    } else if (
      offer == 0 &&
      (label == CollegeProgressSteps.ACTIVE ||
        label == CollegeProgressSteps.TARGET ||
        label == CollegeProgressSteps.CONTACT ||
        label == CollegeProgressSteps.INTEREST)
    ) {
      props.handleStepperUpdate(userCollegeId, index + 1);
      setSteps(index + 1);
    }
  };

  const deleteCommitment = async (commitmentData, collegeId) => {
    props.addMyCommitmentStart({
      query: saveMyCommitmentQuery,
      variables: {
        obj: {
          id:
            commitmentData && commitmentData[0].id
              ? commitmentData[0].id
              : null,
          active: 0,
        },
      },
      collegeId,
    });

    if (mySignedCommitment.length > 0) {
      await deleteSignedCommitment(mySignedCommitment[0].id);
    }
  };

  const handleCategoryChange = (e) => {
    const newCategoryId = e.target.value;
    props.handleUpdateCategory(userCollegeId, newCategoryId);
    setCategory(newCategoryId);
  };
  const handleChangeInterest = async (e) => {
    const newInterestLevelId = e.target.value;
    if (isFavCollegeOffer && isFavCollegeOffer[0]?.id) {
      props.offersListsaveStart({
        query: saveOffersQuery,
        variables: {
          obj: {
            id: isFavCollegeOffer[0] && isFavCollegeOffer[0]?.id,
            interestlevelid: newInterestLevelId,
          },
        },
      });
    }
    const userCollegeVar = {
      obj: {
        userid: getUserInfo() && getUserInfo().id ? getUserInfo().id : null,
        id: userCollegeId,
        collegeinterestlevel: Number(newInterestLevelId),
      },
    };
    await fetchGraphMethod(saveUserCollegeQuery, userCollegeVar, true);
    setMyInterestLevel(newInterestLevelId);
  };

  const isCollegeAddedToOffer = () => {
    const collegeOffers = myOffers.filter((collegeOffer) => {
      return collegeOffer.collegeid === collegeId;
    });

    if (collegeOffers) {
      setIsFavCollegeOffer(collegeOffers);
    }
    return collegeOffers;
  };

  const handleUnfavorite = async () => {
    warningMessagePopup(
      '',
      'This will remove the college from you My Colleges list. Any Offers, Commitments, and Signed Commitments will be deleted as well.',
      'warning'
    ).then(async (res) => {
      if (res) {
        await fetchMethod(
          '/api/Usercolleges/removeCollege',
          {
            userId: getUserInfo().id,
            collegeRank: rank,
            collegeid: collegeId,
          },
          'post',
          true
        ).then(() => {
          props.getCardCount();
          props.getSearchCollegesData();
          toastr.success('College  has been removed as Favorite!', '', {
            progressBar: true,
            timeOut: 2000,
            closeButton: true,
            positionClass: 'toast-top-full-width',
            showEasing: 'swing',
            fadeIn: 40000,
            preventDuplicates: true,
          });
        });
      }
    });
  };

  //This will warn while clicking and once they press ok then only redirect otherwise not.
  const handleMessageEnvelop = () => {
    warningMessagePopup(
      '',
      'The message center is coming soon. You are being redirected to the recruiting tab to contact college coaches directly',
      'warning'
    ).then(async (res) => {
      if (res) {
        props.route &&
          props.route.history.push(`/colleges/details/${collegeId}/1`);
      }
    });
  };

  const saveViewsOfCollege = () => {
    props.viewCollegeSaveStart({
      query: saveViewCollegeQuery,
      variables: {
        obj: {
          athleteid: getUserInfo() ? getUserInfo().id : null,
          collegeid: collegeId,
          collegeviewstatus: 1,
        },
      },
    });
  };

  return (
    <>
      <div className="dataItem" style={{ position: 'relative' }}>
        <div className="dataFlex">
          <div className="leftData">
            <div className="sort handle">
              <svg
                xmlns="http://www.w3.org/2000/svg"
                xmlnsXlink="http://www.w3.org/1999/xlink"
                version="1.1"
                id="Layer_1"
                x="0px"
                y="0px"
                width="50px"
                height="50px"
                viewBox="0 0 114 81"
                enableBackground="new 0 0 114 81"
                xmlSpace="preserve"
              >
                <image
                  id="image0"
                  width="114"
                  height="81"
                  x="0"
                  y="0"
                  href="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAHIAAABRCAMAAAA5OwLXAAAABGdBTUEAALGPC/xhBQAAACBjSFJN AAB6JgAAgIQAAPoAAACA6AAAdTAAAOpgAAA6mAAAF3CculE8AAAB71BMVEX////8/fyurq79/v12 dnYJCQkQEBCYmJj5+vl5enkCAgIAAAAPDw+ampr5+fl8fHwSEhKcnJz9/f3+/v54eHiZmZl1dnUB AQEODg6Xl5cNDQ36+vp5eXn4+fgRERGLjIudnZ34+Pg7Ozs9PT329vbJycl1dXVvb29wcHAvLy8u Li50dHTGx8b8/PxtbW1qamr7+/unp6egoKCioqKbm5saGhrAwMBsbGxpaWnCwsIdHR0FBQVycnIT ExOzs7N2d3a1tbUUFBRzdHOenp60tLTl5eR7e3p6enrj5OO3t7cVFRX39/e5ubkWFhYCAQJ3d3d9 fX24uLiysrLY2dja2tqura5/f39yc3L+//45OTna2tnc3NxxcnHKysrNzc36+/rLy8vOzs4XFxej o6OPkI/19fVTU1NRUVH09PTDw8MjIyMiIiIhISEgICC9vb27u7sUExPKyckVFBQDAwMfHx8tLS0s LCwmJiZbW1vl5eXn5+ddXV0EBAS/v78kJCSVlZXb29vU1NTR0dHr6+vs7Oy2trbBwcHS09JPTk9J SUlKSkpOTk7Q0dC+vr68vLywsLC6urosLCvP0M/R0tEuLy7GxsbHx8fu7u7t7e1mZmZjY2OjpKNQ UFBLS0tMTExPT0+hoqFCQkFAQD8lJSUqKioKXhdVAAAAAWJLR0QAiAUdSAAAAAd0SU1FB+YDGQkh DOyAUr0AAALASURBVGje7Zf5VxJBHMA3Icr9Zi6uBWJRWkEXnYRRrUV2aZJBh12Sdidsp0IXKNJl pdkJHXb/oc2uDO4qmMjs9HxvPz/tznfefN7sfPnOF4bR0dHR0dHR0ZmFzCkro2w0GOea5lE1zi9n ARZUUDQurERGAM5cRcvIV8tG5FxES7nYAlmsNXT2aGQhh41GDtUuURjRPrXPoaWVKiOAXesc4pdZ YAL25doq6+phEitWautc5XCudq7BtrXoZd16bY0InndtwMqNmxhec6FE1bjSRUVIUbl5y1TKrW4D caPbus2DlQ1YuR0rvTt27iJ9qmYrCI3ZZ74cK3fjMrDHB+zeWpJCvokDEPbh1/0HHEaE4+AhPNLc AsBWHyZoNAtoS77mwjNa/WjCkTZy+6wwybfG0UAwGCw7po4dP4EGAyet0gxL+ylSRnk9sNgEjuNs p88oY2frbWhQsI2VXss5MjnktqpKqq9DGQz5VUG2/XzpQr7Jrq7i/k5luOuCOsq2lZ5DFwUoRglw qdRve/kKFKm8eq3UXV7vLk4Z9sxQpMATUa/ZMqVSvFG6kWFuhlWL3rqtDIbuqI0BEsac825PbzQa jd27r4w9eBhDg73iI3lKpJWMkWHiCWk9U19/MpkcSKljjwfQYH+N/EvqJvJVx/BKTt+TwhPkGhuO kzMyzNOw8iZ59nzwBWLw5Ss8It0k4hBJI8MMh4F7nX3O0xU0CiASO0fMSOzN28LKd+8ThHJVSecH /JSv9/nYMbNVp8n/aCqdWNlAQ+lKZzKpT1j5OZXOpDXWGr58Hf02KmJlD3r5/kPbf3t1P2ESvwg2 dvnw/p5oTBC4rf7hVN8rECFa5fITVznFYe2NqA4p+oSIBjUnH0OJXNdBZY8S3lg2cyicY84pn6dI 0YhyCJ1nhGAPMB1Gon8oZc44XSHaRh0dHZ1ZxV/IJo/iwCtPaQAAACV0RVh0ZGF0ZTpjcmVhdGUA MjAyMi0wMy0yNVQwNjozMzoxMiswMzowMLRP2IwAAAAldEVYdGRhdGU6bW9kaWZ5ADIwMjItMDMt MjVUMDY6MzM6MTIrMDM6MDDFEmAwAAAAAElFTkSuQmCC"
                />
              </svg>
            </div>
            <div className="count">#{rank}</div>
            <div className="data">
              <div className="headFlex">
                <div className="icon">
                  <img
                    style={
                      logo && logo?.includes('.svg') ? { width: '100%' } : {}
                    }
                    src={imgSrc}
                    alt="Team Logo"
                  />
                </div>
                <div>
                  <h5>
                    <Link
                      to={`/colleges/details/${collegeId}/1 `}
                      onClick={saveViewsOfCollege}
                    >
                      {name}
                    </Link>
                  </h5>
                  <p>
                    {conference} <br />
                    {city}, {stateInitials} <br />
                    {division}
                  </p>
                </div>
              </div>
              <div className="stepperBox">
                {stepsList &&
                  stepsList.map((item, index) => (
                    <div
                      className={`item ${
                        item.active ? 'active' : item.passed ? 'passed' : ''
                      }`}
                      key={index}
                    >
                      <span
                        className="circle"
                        data-testid={item.label}
                        onClick={() =>
                          handleStepperUpdateData(index, item.label)
                        }
                      ></span>
                      <span>{item.label}</span>
                    </div>
                  ))}
              </div>
            </div>
          </div>
          <div className="rightData">
            <div className="actionBox">
              <div className="actionFlexBox">
                <ul>
                  <li>
                    <Link
                      onClick={() => handleUnfavorite()}
                      to="#"
                      className="powerLink"
                    >
                      <img src={favorite} alt="Favorite" />
                    </Link>
                  </li>
                  <li>
                    <Link
                      onClick={() => handleMessageEnvelop()}
                      to="#"
                      className="directionLink"
                    >
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="25px"
                        height="25px"
                        viewBox="0 0 24.006 19.205"
                      >
                        <g id="email" transform="translate(-1 -4)">
                          <path
                            id="Path_369"
                            data-name="Path 369"
                            d="M24.973,6.512A2.948,2.948,0,0,0,22.066,4H3.963A2.948,2.948,0,0,0,1.056,6.512L13.014,14.25Z"
                            transform="translate(-0.011)"
                            fill="#3e3e3e"
                          />
                          <path
                            id="Path_370"
                            data-name="Path 370"
                            d="M13.438,16.971a.8.8,0,0,1-.869,0L1,9.486V21.349A2.955,2.955,0,0,0,3.952,24.3h18.1a2.955,2.955,0,0,0,2.952-2.952V9.485Z"
                            transform="translate(0 -1.096)"
                            fill="#3e3e3e"
                          />
                        </g>
                      </svg>
                    </Link>
                  </li>
                  <li>
                    <Link
                      to="#"
                      onClick={() => setOpenMap(true)}
                      className="locationLink"
                    >
                      <img src={location} alt="Location" />
                    </Link>
                  </li>
                  <li>
                    <div
                      className="badgeBox"
                      onClick={() =>
                        swal({
                          text: 'This feature is available for premium members only',
                          icon: 'warning',
                        })
                      }
                    >
                      <Link to="#">
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          width="25"
                          height="25"
                          viewBox="0 0 27.533 27.533"
                          fill={isTagged == 1 ? '#ff6624' : 'none'}
                        >
                          <g
                            id="tag-black-shape"
                            transform="translate(0.498 0.5)"
                          >
                            <path
                              id="Path_438"
                              data-name="Path 438"
                              d="M25.887,14.1,13.365,1.594A5.424,5.424,0,0,0,11.579.464,5.411,5.411,0,0,0,9.529,0H2.244A2.155,2.155,0,0,0,.667.665,2.154,2.154,0,0,0,0,2.242V9.527a5.407,5.407,0,0,0,.464,2.049A5.219,5.219,0,0,0,1.6,13.345l12.522,12.54a2.145,2.145,0,0,0,1.576.648,2.243,2.243,0,0,0,1.594-.648l8.6-8.617a2.145,2.145,0,0,0,.648-1.576A2.244,2.244,0,0,0,25.887,14.1ZM7.191,7.189a2.161,2.161,0,0,1-1.585.657A2.243,2.243,0,0,1,3.365,5.6,2.243,2.243,0,0,1,5.606,3.363,2.243,2.243,0,0,1,7.848,5.6,2.159,2.159,0,0,1,7.191,7.189Z"
                              transform="translate(0 0)"
                              fill={isTagged == 1 ? '#ff6624' : 'none'}
                              stroke="#ff6624"
                              strokeWidth="1"
                            />
                          </g>
                        </svg>
                      </Link>
                    </div>
                  </li>
                </ul>
              </div>
            </div>
          </div>
          <ul className="UpdateFlexBox">
            <li>
              <label>Category :</label>
              <span>
                <select
                  name="category"
                  value={category}
                  onChange={(e) => handleCategoryChange(e)}
                  data-testid="Category"
                >
                  {props.categories &&
                    props.categories.map((item, index) => (
                      <option key={index} value={item.id}>
                        {item.categoryname}
                      </option>
                    ))}
                </select>
              </span>
            </li>
            <li>
              <label>My Interest Level :</label>
              <select
                name="interest"
                value={myInterestLevel}
                onChange={(e) => handleChangeInterest(e)}
              >
                <option>Select</option>
                {props.interestLevels &&
                  props.interestLevels.map((item, index) => (
                    <option key={index} value={item.id}>
                      {item.interestlevelvalue}
                    </option>
                  ))}
              </select>
            </li>
            <li>
              <label>Last Updated :</label>
              <span>{getSlashFormattedDate(updatedOn)}</span>
            </li>
          </ul>
        </div>
        <div className="collapseBox">
          <CollegeOverview
            conference={conference}
            academicSelectivity={academicSelectivity}
            schoolSize={schoolSize}
            tuitionInCost={tuitionInCost}
            tuitionOutCost={tuitionOutCost}
          />
        </div>
      </div>
      <Dialog
        open={signedModal}
        onClose={(event, reason) => {
          if (reason == 'backdropClick' || reason == 'escapeKeyDown') {
            closeCommitModal();
          }
        }}
        className="matDialogCustom"
      >
        <div
          className="modal fade commitment-modal show"
          style={{ display: 'block' }}
          id="CommitmentModal"
        >
          <div className="modal-dialog modal-dialog-centered" role="document">
            <form className="modal-content">
              <div className="modal-header">
                <h5 className="modal-title">
                  {mySignedCommitment.length > 0
                    ? 'Edit Signed Commitment'
                    : 'Add Signed Commitment'}
                </h5>
                <button
                  onClick={() => closeSignedModal()}
                  type="button"
                  className="close"
                  data-dismiss="modal"
                  aria-label="Close"
                >
                  <span aria-hidden="true">&times;</span>
                </button>
              </div>
              <div className="modal-body">
                <div className="img-box">
                  <img src={imgSrc} alt="Team Logo" />
                </div>
                <h3>{name}</h3>
                <p>
                  {conference} <br />
                  {city}, {stateInitials} <br />
                  {division}
                </p>
                <div className="add-commitment-button">
                  {mySignedCommitment.length > 0 ? (
                    <Link
                      to={{
                        pathname: '/viewCommitment',
                      }}
                    >
                      Edit Signed Commitment
                    </Link>
                  ) : (
                    <Link
                      to={{
                        pathname: '/viewCommitment',
                        state: {
                          id: collegeId,
                          collegename: name,
                          isSigned: true,
                          city,
                          state,
                          active: 1,
                        },
                      }}
                    >
                      Add Signed Commitment
                    </Link>
                  )}
                </div>
              </div>
              <div className="modal-footer">
                <button
                  onClick={() => closeSignedModal()}
                  type="button"
                  className="btn"
                  data-dismiss="modal"
                >
                  Cancel
                </button>
              </div>
            </form>
          </div>
        </div>
      </Dialog>
      <Dialog
        open={commitModal}
        onClose={(event, reason) => {
          if (reason == 'backdropClick' || reason == 'escapeKeyDown') {
            closeCommitModal();
          }
        }}
        className="matDialogCustom"
      >
        <div
          className="modal fade commitment-modal show"
          style={{ display: 'block' }}
          id="CommitmentModal"
        >
          <div className="modal-dialog modal-dialog-centered" role="document">
            <form className="modal-content">
              <div className="modal-header">
                <h5 className="modal-title">
                  {commit == 1 ? 'Edit Commitment' : 'Add Commitment'}
                </h5>
                <button
                  onClick={() => closeCommitModal()}
                  type="button"
                  className="close"
                  data-dismiss="modal"
                  aria-label="Close"
                >
                  <span aria-hidden="true">&times;</span>
                </button>
              </div>
              <div className="modal-body">
                <div className="img-box">
                  <img src={imgSrc} alt="Team Logo" />
                </div>
                <h3>{name}</h3>
                <p>
                  {conference} <br />
                  {city}, {stateInitials} <br />
                  {division}
                </p>
                <div className="add-commitment-button">
                  {commit == 1 ? (
                    <Link
                      to={{
                        pathname: '/viewCommitment',
                      }}
                    >
                      Edit Commitment
                    </Link>
                  ) : (
                    <Link
                      to={{
                        pathname: '/viewCommitment',
                        state: {
                          id: collegeId,
                          collegename: name,
                          isSigned: false,
                          city,
                          state,
                          active: 1,
                        },
                      }}
                    >
                      Add Commitment
                    </Link>
                  )}
                </div>
              </div>
              <div className="modal-footer">
                <button
                  onClick={() => closeCommitModal()}
                  type="button"
                  className="btn"
                  data-dismiss="modal"
                >
                  Cancel
                </button>
              </div>
            </form>
          </div>
        </div>
      </Dialog>
      <Dialog
        open={offerModal}
        onClose={(event, reason) => {
          if (reason == 'backdropClick' || reason == 'escapeKeyDown') {
            closeOfferModal();
          }
        }}
        className="matDialogCustom"
      >
        <div
          className="modal fade commitment-modal show"
          style={{ display: 'block' }}
          id="OfferModal"
        >
          <div className="modal-dialog modal-dialog-centered" role="document">
            <form className="modal-content">
              <div className="modal-header">
                <h5 className="modal-title">
                  {props.data.offer ? 'Edit Offer' : 'Add Offer'}
                </h5>
                <button
                  onClick={() => closeOfferModal()}
                  type="button"
                  className="close"
                  data-dismiss="modal"
                  aria-label="Close"
                >
                  <span aria-hidden="true">&times;</span>
                </button>
              </div>
              <div className="modal-body">
                <div className="img-box">
                  <img src={imgSrc} alt="Team Logo" />
                </div>
                <h3>{name}</h3>
                <p>
                  {conference} <br />
                  {city}, {stateInitials} <br />
                  {division}
                </p>
                <div className="add-commitment-button">
                  <Link
                    to={{
                      pathname: '/Offers',
                      state: {
                        collegeOfferId:
                          isFavCollegeOffer &&
                          isFavCollegeOffer[0] &&
                          isFavCollegeOffer[0].id
                            ? isFavCollegeOffer[0].id
                            : null,
                        id: collegeId,
                        collegename: name,
                        interestLevel: myInterestLevel,
                        offerType: props.data.offer
                          ? isFavCollegeOffer &&
                            isFavCollegeOffer[0] &&
                            isFavCollegeOffer[0].offerid
                            ? isFavCollegeOffer[0].offerid
                            : null
                          : null,
                        offerDate:
                          isFavCollegeOffer && isFavCollegeOffer[0]
                            ? isFavCollegeOffer[0].offerdate
                            : null,
                      },
                    }}
                  >
                    {props.data.offer
                      ? 'Edit Offer for this college'
                      : 'Add Offer for this college'}
                  </Link>
                </div>
              </div>
              <div className="modal-footer">
                <button
                  onClick={() => closeOfferModal()}
                  type="button"
                  className="btn"
                  data-dismiss="modal"
                >
                  Cancel
                </button>
              </div>
            </form>
          </div>
        </div>
      </Dialog>
      <Dialog
        open={openMap}
        onClose={() => {
          setOpenMap(false);
        }}
      >
        <div className="map-modal-wrap">
          <div className="mapclose-button">
            <button onClick={() => setOpenMap(false)}>&times;</button>
          </div>
          <Map markers={[{ latitude: Number(lat), longitude: Number(lng) }]} />
        </div>
      </Dialog>
    </>
  );
};

const mapStateToProps = (state) => {
  return {
    interestLevelDetails: state.common.interestLevelList,
    profileView: state.athlete.dashboard.colleges.userprofileView,
    messageReplyList: state.athlete.dashboard.messageReply.messageReplyList,
  };
};
const mapDispatchToProps = (dispatch) => {
  return {
    addMyCommitmentStart: (data) => dispatch(addMyCommitmentStart(data)),
    offersListsaveStart: (data) => dispatch(offersListsaveStart(data)),
    updateUserCollegeStart: (data) => dispatch(updateUserCollegeStart(data)),
    userProfileViewListStart: (data) =>
      dispatch(userProfileViewListStart(data)),
    messageReplyListStart: (data) => dispatch(messageReplyListStart(data)),
    userCollegeCardCountStart: (data) =>
      dispatch(userCollegeCardCountStart(data)),
    viewCollegeSaveStart: (data) => dispatch(viewCollegeSaveStart(data)),
  };
};
export default connect(mapStateToProps, mapDispatchToProps)(CollegeCard);
